export default __webpack_public_path__ + "static/media/edit.0f46e272.png";